import {Typography, Box, Switch} from '@mui/material'
import React from 'react'

type BaseSwitchInputProps = {
  title: string
  checked: boolean
  onChange: (checked: boolean) => void
  testId: string
  marginBottom?: number
}

export const BaseSwitchInput: React.FC<BaseSwitchInputProps> = ({
  title,
  checked,
  onChange,
  testId,
  marginBottom = 16
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: `${marginBottom}px`
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '24px',
          color: '#29333d',
          textAlign: 'left'
        }}
      >
        {title}
      </Typography>

      <Switch
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        sx={{
          width: 44,
          height: 24,
          padding: 0,
          '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: '2px',
            transitionDuration: '300ms',
            '&.Mui-checked': {
              transform: 'translateX(20px)',
              color: '#fff',
              '& + .MuiSwitch-track': {
                backgroundColor: '#016ad4',
                opacity: 1,
                border: 0
              },
              '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5
              }
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
              color: '#016ad4',
              border: '6px solid #fff'
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
              color: '#f5f5f5'
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              opacity: 0.3
            }
          },
          '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 20,
            height: 20,
            boxShadow: '0px 3px 1px rgba(0,0,0,0.06), 0px 3px 8px rgba(0,0,0,0.15)'
          },
          '& .MuiSwitch-track': {
            borderRadius: 12,
            backgroundColor: '#d1d9e0',
            opacity: 1,
            transition: 'background-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
          }
        }}
        data-test-id={testId}
      />
    </Box>
  )
}
